<div class="section-container">
  <div class="sub-section">
    <div class="section-header">
      <img src="/assets/icons/icon-shield.png" alt="Icon" />
      <h2>Privacy Disclosure</h2>
    </div>

    <div class="section-content">
      <ng-container *ngTemplateOutlet="privacyQuestionTemplate; context: { 
        question: 'Does the SDK have a privacy policy?',
        value: data?.overview?.hasPrivacyPolicy
      }"></ng-container>

      <ng-container *ngTemplateOutlet="privacyQuestionTemplate; context: { 
        question: 'Does the SDK\'s privacy policy declare location collection?',
        value: data?.riskOverview?.privacyPolicyAnyLocation
      }"></ng-container>

      <ng-container *ngTemplateOutlet="privacyQuestionTemplate; context: { 
        question: 'Does the SDK\'s privacy manifest file declare precise location collection?',
        value: data?.riskOverview?.preciseLocationDeclared
      }"></ng-container>
    </div>
  </div>

  <div class="sub-section">
    <div class="section-header">
      <img src="/assets/icons/icon-technical.png" alt="Icon" />
      <h2>Technical Behavior</h2>
    </div>

    <div class="section-content">
      <ng-container *ngTemplateOutlet="privacyQuestionTemplate; context: { 
        question: 'Does the SDK collect precise location information?',
        value: data?.riskOverview?.preciseLocationDetected2
      }"></ng-container>

      <ng-container *ngTemplateOutlet="privacyQuestionTemplate; context: { 
        question: 'Does the SDK transmit users\' precise location data off-device?',
        value: data?.riskOverview?.preciseLocationEmitted2
      }"></ng-container>
    </div>
  </div>
</div>

<ng-template #privacyQuestionTemplate let-question="question" let-value="value" let-tooltip="tooltip">
  <div class="section-details">
    <span class="text-question">{{ question }}</span>
    <span class="text-value {{ (value | yesno) }}">{{ (value | yesno:"capitalize") }}</span>
  </div>
</ng-template>